/* eslint-disable import/prefer-default-export */
import _isEmpty from 'lodash/isEmpty';
import * as types from '../constants/ActionTypes';
import { chatBotContactTo, chatBotQueryParams, contactPage } from '../constants/UtilVariables';
import { fetchPhoneNumber } from './action-call-us';
import getTopicTree from '../../home/actions/action-topic-list';
import { accessLogoutEmail } from './action-email-no-intent';
import { fetchTopicTree } from './action-message-topic-tree';
import { fetchRelatedTopic } from './action-quick-answer-topics';
import Page from '../../lib/page';
import fetchPPCEnable from './action-ppc-checker';
import { fetchChatBotSessionChecker } from './action-chat-bot';
import providePPMEmailFields, { parseIpInfringementWebform } from './action-paypalme-email';
import {
  isIpInfringementHardcodeFormEnabled,
  isWebFormWithoutTCodeEnabled,
  validateAMFlag,
} from '../../lib/globalHelper';
import { returnTcodeWithEmailQuery } from '../../lib/puiTopicHelper';
import { getLastPathVariable, securityUrlListCheck } from '../../lib/location-helper';
import { isNewContactUsExpEnabled } from '../../../jsV2/helpers/twHelper';

export const redirectLocation = ({ pageName }) => ({
  type: types.CONTACT_LOCATION_CHANGE,
  payload: { pageName },
});

// Fetch data for Call Page
function fetchCallPageRequests(chatBotParams) {
  return (dispatch) => {
    // Trigger callus API only to the users other than loggedin and nonidienabled
    if (!validateAMFlag()) {
      dispatch(fetchPhoneNumber(chatBotParams));
    }
    if (Page.isLoggedIn() && Page.getIsMarketEnabledForPPCreditTab()) {
      dispatch(fetchPPCEnable());
    }
  };
}

/**
 * Updating email form reducer with all the hardcoded ipinfirngement form elements
 */
export const updateIpInfringementEmailFields = () => ({
  type: types.PROVIDE_PPM_EMAIL_FIELDS,
  payload: parseIpInfringementWebform(),
});

// fetch data for Email Page
function fetchEmailPageRequests(options) {
  return (dispatch) => {
    // Using Hardcode webform data for PayPalMe/aupviolation controlled by remote config
    if (Page.isAUPHardcodeFormEnabled()) {
      dispatch(providePPMEmailFields());
    }
    if (isIpInfringementHardcodeFormEnabled()) {
      dispatch(updateIpInfringementEmailFields());
    } else {
      dispatch(fetchTopicTree(options));
    }

    dispatch(getTopicTree());
    const pathVariable = getLastPathVariable(window.location);
    const faqTopic = (Page.getWebformFaqTopic() && Page.getWebformFaqTopic()[pathVariable]) || {};
    if (faqTopic.isEnabled && faqTopic.topic) {
      dispatch(fetchRelatedTopic(faqTopic.topic));
    }
  };
}

// Redirect to Call or Email page based on current pageName
function redirectToCallOrEmail(pageName) {
  return (dispatch) => {
    if (pageName === contactPage.callUs) {
      dispatch(fetchCallPageRequests()); // Fetch data for Call Us
    } else if (pageName === contactPage.email) {
      dispatch(fetchEmailPageRequests({ email: true })); // Fetch data for Email Page
    } else if (!isNewContactUsExpEnabled()) {
      // Loading Topic tree data in the Contact landing page
      dispatch(fetchTopicTree());
    }
  };
}

function checkChatBotSession(redirect = {}) {
  return (dispatch) => {
    const chatBotQueryRedirectParam = Page.getChatBotContactTo();
    const urlListCheck = !!securityUrlListCheck(document.referrer);
    const chatBotParams = {};
    if (chatBotQueryRedirectParam && chatBotQueryRedirectParam === chatBotContactTo.call) {
      chatBotParams.topic_code = Page.getQueryParamValue(chatBotQueryParams.TOPIC_CODE);
      chatBotParams.topic_key = Page.getQueryParamValue(chatBotQueryParams.TOPIC_KEY);
    }
    // Login and chatBot checker
    if (!chatBotQueryRedirectParam || !Page.isLoggedIn()) {
      // logged out version. Chat will also be false
      if (chatBotQueryRedirectParam && chatBotContactTo.call === chatBotQueryRedirectParam && urlListCheck) {
        chatBotParams.chatbot = false;
        return redirect.callUs(chatBotParams);
      }
      return redirect.default(); // default redirect logic
    }

    const chatBotSessionChecker = (responseData) => responseData && !_isEmpty(responseData.chatState);
    // Redirect to Call or Email page for ChatBot;
    const options = {};
    // eslint-disable-next-line no-shadow
    options.callBack = (responseData) => {
      const isChatStateExists = chatBotSessionChecker(responseData);
      if (!responseData || !isChatStateExists) {
        // if the chat bot session doesn't exist and query parameter has call us
        // check the referrer list from RC and if the current referrer URL exsist in the list redirect to call us page
        if (chatBotContactTo.call === chatBotQueryRedirectParam && urlListCheck) {
          chatBotParams.chatbot = isChatStateExists;
          return redirect.callUs(chatBotParams);
        }
        return redirect.default(); // default redirect
      }
      if (chatBotContactTo.email === chatBotQueryRedirectParam) {
        return redirect.email(); // Email redirect
      }
      if (chatBotContactTo.call === chatBotQueryRedirectParam) {
        chatBotParams.chatbot = isChatStateExists;
        return redirect.callUs(chatBotParams); // Call redirect
      }
      return redirect.default(); // default redirect if the chatBotQuery is not validate
    };

    return dispatch(fetchChatBotSessionChecker(options));
  };
}

// Check Current location and send API request for different locations
export const locationChecker = () => (dispatch, getState) => {
  const state = getState();
  const {
    location: { pageName },
  } = state;
  // query checker for logout Email; have validate refId for `email` query
  // getting the tcode from pui config remote config with the email query in the url as tcode is not available during page load
  const emailRef = Page.getLogoutEmailRefId() || returnTcodeWithEmailQuery();

  if (isWebFormWithoutTCodeEnabled()) {
    // Redirecting to complaints web-form without T-CODE
    dispatch(redirectLocation({ pageName: contactPage.emailNoTCode }));
  } else if (emailRef) {
    // Redirect to Logout WebForm
    dispatch(redirectLocation({ pageName: contactPage.email }));
    dispatch(fetchEmailPageRequests({ emailRef, logoutEmail: true }));
    dispatch(accessLogoutEmail());
  } else {
    // ChatBot redirect switcher
    const redirect = {
      default: () => {
        // if pageName is undefined which is initial state then redirect the location to contactUs home.
        // else redirect to appropriate page location.
        if (!pageName) {
          dispatch(redirectLocation({ pageName: contactPage.contactUs }));
          dispatch(redirectToCallOrEmail(contactPage.contactUs));
        } else {
          dispatch(redirectLocation({ pageName }));
          dispatch(redirectToCallOrEmail(pageName));
        }
      },
      email: () => {
        dispatch(redirectLocation({ pageName: contactPage.email }));
        dispatch(fetchEmailPageRequests({ email: true }));
      },
      callUs: (chatBotParams) => {
        dispatch(redirectLocation({ pageName: contactPage.callUs }));
        dispatch(fetchCallPageRequests(chatBotParams));
      },
    };

    // Check chatBot query and chatBot session data.
    // Based on the chatBot session response redirect to appropriate channel.
    dispatch(checkChatBotSession(redirect));
  }

  return {
    type: types.CONTACT_LOCATION_LOAD,
  };
};

// Update current location action, if users go to Email/CallUs page/Channel Steering
export const locationUpdate =
  ({ pageName }) =>
  (dispatch) => {
    if (pageName) {
      dispatch(redirectLocation({ pageName }));
      dispatch(locationChecker());
    }
  };

export const exportedForTesting = {
  fetchCallPageRequests,
  fetchEmailPageRequests,
  redirectToCallOrEmail,
  checkChatBotSession,
};
